"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormattedDate = void 0;

var _alloyReactDatetime = require("@adsk/alloy-react-datetime");

const getFormattedDate = d => {
  const date = new Date(d);
  return `${(0, _alloyReactDatetime.displayDate)(date)} ${(0, _alloyReactDatetime.displayTime)(date, {
    format: "short"
  })}`;
};

exports.getFormattedDate = getFormattedDate;